
import { Vue, Component } from "vue-property-decorator";
import {
  IPatientProfileUpdate,
  IUserProfileResponsibleNurses,
  IVisitProfile,
  QuestObject,
  QuestObjectMeasurement,
} from "@/interfaces"; //TODO add Woundprofile
import {
  readPatient,
  readPatientID,
  readQRPatient,
  readBreeds,
  readVisits,
  readVisitsQuest,
  readLanguage,
  readEditHorse,
} from "@/store/admin/getters";
import { readHasAdminAccess } from "@/store/main/getters";
import {
  commitSetPatientID,
  commitSwitchLanguage,
} from "@/store/admin/mutations";
import {
  dispatchGetPatients,
  dispatchGetQRPatient,
  dispatchUpdatePatient,
  dispatchGetVisits,
  dispatchGetVisitsQuest,
} from "@/store/admin/actions";
import { jsPDF } from "jspdf";
import { api } from "@/api";
import { readToken, readUserProfile } from "@/store/main/getters";
import myUpload from 'vue-image-crop-upload/upload-2.vue';
import { Console } from "console";
import Quest from "./Quest.vue";

@Component({
  components: {
    'my-upload': myUpload
  },
})
export default class PatientOverview extends Vue {
  public search = "";
  public searchNurses = "";

  public nurses: IUserProfileResponsibleNurses[] = [];
  public nursesNew: IUserProfileResponsibleNurses[] = [];
  public nurseParse: String[] = [];
  public show: boolean = false;
  public nurse_select: number = -1;

  public dialog = false;
  public dialogInfo = false;
  public dialogDelete = false;
  public dialogDeleteHoove = false;
  public dialogOwner = false;

  public b64: string = "";

  //for the editPatient
  public editable = false;
  public birthday: Date = new Date(1900, 1, 1);
  public birthplace = "";
  public nationality = "";
  public firstname = "";
  public lastname = "";
  public gender = "";
  public city = "";
  public postcode = 0;
  public road = "";
  public house_number = "";
  public genders_eng = ["Stallion", "Filly/Mare", "Gelding"];
  public genders_german = ["Hengst", "Stute", "Wallach"];
  public dialogQR = false;
  public breed: String = "";

  public quest: QuestObject = {
    anamnesis: "",
    vacc_state: "",
    living_cond: "",
    abrasion: "",
    nurtri_state: "",
    date: ""
  };

  public postcodeRules = [
    v => v > 0 || 'Darf nicht negativ sein',
    v => String(v).length === 5 || 'Muss genau 5 Ziffern haben'
  ]


  public mountPic: boolean = false;

  get genders() {
    if (this.language) {
      return this.genders_eng
    } return this.genders_german
  }
  
  public dummy = [
    { firstname: "Barabara", lastname: "Fitch", id: 11 },
    { firstname: "Jo", lastname: "Weihndoc", id: 12 },
  ];

  public headers = [
    {
      // text: "Name",
      text: "",
      sortable: true,
      value: "name",
      align: "center",
    },
    /*{
      // text: "ID ",
      text: "",
      sortable: false,
      value: "id",
      align: "left",
    },*/
    // {
    //   text: "ICD",
    //   sortable: false,
    //   value: "icd",
    //   align: "left",
    // },
  ];

  public headersVisit = [
    {
      text: "Date",
      sortable: true,
      value: "date",
      align: "left",
    },
    {
      text: "Percentage ",
      sortable: false,
      value: "percentage",
      align: "center",
    },
  ];

  public headersVisit_german = [
    {
      text: "Datum",
      sortable: true,
      value: "date",
      align: "left",
    },
    {
      text: "Vollständigkeitsgrad",
      sortable: false,
      value: "percentage",
      align: "center",
    },
  ];

  public headersNurses = [
    {
      text: "Name",
      sortable: true,
      value: "name",
      align: "left",
    },
  ];

  get anamnesis() {
    return this.quest.anamnesis;
  }

  get vacc_state() {
    return this.quest.vacc_state;
  }

  get living_cond() {
    return this.quest.living_cond;
  }

  get abrasion() {
    return this.quest.abrasion;
  }

  get nutri_state() {
    return this.quest.nurtri_state;
  }

  get date() {
    return this.quest.date.substring(0, 10);
  }

  showWoundCreate() { }
  //gets the patient from the patients by the id from the admin state

  get patient() {
    return readPatient(this.$store)(+this.$router.currentRoute.params.id);
  }

  get wounds() {
    return this.patient!.wounds;
  }

  get hasAdminAccess() {
    return readHasAdminAccess(this.$store);
  }

  get language() {
    return readLanguage(this.$store);
  }

  get searchLabel() {
    return this.$t("search") as string;
  }

  private triggerDialog() {
    this.dialogOwner = !this.dialogOwner;
  }

  // Everything regarding portrait styling

 get isMdOnly(): boolean {
    return this.$vuetify.breakpoint.mdOnly;
  }

// ---------------------------------------

  public handleClick() {
    console.log("WELL YEAH");
  }

  public editOrNot() {
    return !this.hasAdminAccess;
  }

  public getRandomPercentage() {
    const chance = Math.random(); // ergibt Wert zwischen 0 und 1

    if (chance < 0.8) {
      return 100;
    } else {
      return Math.floor(Math.random() * (99 - 10 + 1)) + 10;
    }
  }
  get editableBool() {
    return this.editable;
  }

  public getQR() {
    return "data:image/jpeg;base64," + readQRPatient(this.$store);
  }
  //For imageCropUpload----------------
  public showCropper = false;
  public set = false;
  public imgDataUrl: string = '';
  public params = {
    token: '123456789',
    name: 'avatar'
  };
  public headersCropper = {
    smail: '*_~'
  }

  public de = {
    hint: 'Click or drag the file here to upload',
    loading: 'Uploading…',
    noSupported: 'Dieser Browser wird nicht unterstützt, bitte benutzen sie IE10+ oder vergleichbare.',
    success: 'Hochladen erfolgreich',
    fail: 'Hochladen fehlgeschlagen',
    preview: 'Vorschau',
    btn: {
      off: 'Abbrechen',
      close: 'Schließen',
      back: 'Zurück',
      save: 'Speichern'
    },
    error: {
      onlyImg: 'Nur Bilder',
      outOfSize: 'Bild ist zu groß. Limit ist: ',
      lowestPx: 'Bilder Größe ist zu gering. Mindestgröße ist: '
    }
  }

  public en = {
    hint: 'Click or drag the file here to upload',
    loading: 'Uploading…',
    noSupported: 'Browser is not supported, please use IE10+ or other browsers',
    success: 'Upload success',
    fail: 'Upload failed',
    preview: 'Preview',
    btn: {
      off: 'Cancel',
      close: 'Close',
      back: 'Back',
      save: 'Save'
    },
    error: {
      onlyImg: 'Image only',
      outOfSize: 'Image exceeds size limit: ',
      lowestPx: 'Image\'s size is too low. Expected at least: '
    }
  }

  get text() {
    if (this.language) {
      return this.en;
    } else return this.de;
  }

  public toggleShow() {
    this.showCropper = !this.showCropper;
  }

  cropSuccess(imgDataUrl, field) {
    this.set = true;
    console.log('-------- crop success --------');
    this.imgDataUrl = imgDataUrl;
  }

  cropUploadSuccess(jsonData, field) {
    console.log('-------- upload success --------');
    console.log(jsonData);
    console.log('field: ' + field);
  }

  cropUploadFail(status, field) {
    console.log('-------- upload fail --------');
    console.log(status);
    console.log('field: ' + field);
  }

  private b64Cleaner(b64: string) {
    let newA: String = b64.replace(
      "dataimage/pngbase64",
      "data:image/png;base64,"
    );
    let newB: String = newA.replace(
      "dataimage/jpegbase64",
      "data:image/jpeg;base64,"
    );
    //Removing padding from backend
    let newC = newB.replace(
      "=",
      ""
    )
    return newC;
  }

  //---------------------------------------


  public patientInfo() {
    this.dialogInfo = true;
  }

  public setPatientInfo() {
    if (this.patient?.firstname) {
      this.firstname = this.patient.firstname;
    }
    if (this.patient?.lastname) {
      this.lastname = this.patient.lastname;
    }
    if (this.patient?.nationality) {
      this.nationality = this.patient.nationality;
    }
    if (this.patient?.gender) {
      this.gender = this.patient.gender;
    }
    if (this.patient?.road) {
      this.road = this.patient.road;
    }
    if (this.patient?.city) {
      this.city = this.patient.city;
    }
    if (this.patient?.postcode) {
      this.postcode = this.patient.postcode;
    }
    if (this.patient?.house_number) {
      console.log("House number: " + this.patient.house_number);
      this.house_number = this.patient.house_number;
    }
    if (this.patient?.birthplace) {
      this.birthplace = this.patient.birthplace;
    }
    if (this.patient?.birthday) {
      this.birthday = this.patient.birthday;
    }
    if (this.patient?.breed) {
      this.breed = this.patient.breed;
    }
  }

  public async saveNurse() {
    await api
      .saveNurseToPatient(
        readToken(this.$store),
        this.patient!.id,
        this.nurse_select
      )
      .catch((error) => console.log(error));
    this.$router.push({ name: 'main-horse-overview', params: { id: this.$router.currentRoute.params.id } });

    this.dialog = false;
    this.nurse_select = -1;
    this.updateNurseslist();
  }

  get disableNurse() {
    if (this.nurse_select != -1) {
      return false;
    }
    return true;
  }

  public download() {
    this.$router.push({ name: 'main-horse-visit-all', params: { id: this.$router.currentRoute.params.id } });
  }

  public downloadQuests() {
    this.$router.push({ name: 'main-horse-quest', params: { id: this.$router.currentRoute.params.id } });
  }

  public getFirstLetter() {
    var arr = Array.from(this.firstname);
    if (arr[0]) {
      return arr[0];
    }
    return "";
  }
  public async updateNurseslist() {
    await api
      .getNursesForPatients(readToken(this.$store), this.patient!.id)
      .then((response) => (this.nurses = response.data))
      .catch((error) => console.log(error));
    await api
      .getNotResponsibleNursesForPatients(
        readToken(this.$store),
        this.patient!.id
      )
      .then((response) => (this.nursesNew = response.data))
      .catch((error) => console.log(error));
  }

  public async deleteNurse(idNurse: number) {
    await api.deleteResponsibleNurse(
      readToken(this.$store),
      readPatientID(this.$store),
      idNurse
    );
    this.updateNurseslist();
  }
  //
  get namePatient() {
    if (this.patient) {
      return this.patient.firstname + " " + this.patient.lastname;
    } else {
      return "----";
    }
  }

  get genderStr() {
    if (this.patient) {
      return this.patient.gender;
    } else return "";
  }

  get breeds() {
    return readBreeds(this.$store);
  }

  get visits() {
    return readVisits(this.$store);
  }

  get quests() {
    var quests = readVisitsQuest(this.$store);
    console.log("Quests: " + quests);
    return quests;
  }

  get patientAdress() {
    if (this.city && this.city != "") {
      return this.city;
    } else {
      var adress = "";
      if (this.road) {
        adress += this.road + " ";
      }
      if (this.house_number) {
        adress += this.house_number.toString();
      }
      if (adress.length > 0) {
        adress += ", ";
      }
      if (this.postcode) {
        adress += this.postcode + " ";
      }
      if (this.city) {
        adress += this.city;
      }

      return adress;
    }
  }

  public async deleteWound(id: number) {
    await api.deleteWound(readToken(this.$store), id);
    dispatchGetPatients(this.$store);
    readPatient(this.$store)(+this.$router.currentRoute.params.id);
  }

  public getDate(date: string) {
    var d = new Date(date);
    return this.formatDate(d.toLocaleString());
  }

  //gets the resonsible nurses at the beginning
  public async mounted() {
    dispatchGetQRPatient(this.$store, +this.$router.currentRoute.params.id);
    commitSetPatientID(this.$store, +this.$router.currentRoute.params.id);
    //dispatchGetPatients(this.$store);
    await api
      .getNursesForPatients(readToken(this.$store), this.patient!.id)
      .then((response) => (this.nurses = response.data))
      .catch((error) => console.log(error));
    await api
      .getNotResponsibleNursesForPatients(
        readToken(this.$store),
        this.patient!.id
      )
      .then((response) => (this.nursesNew = response.data))
      .catch((error) => console.log(error));
    var responseb64: string = "";
    await api
      .getLatestQuest(
        readToken(this.$store),
        this.patient!.id)
      .then((response) => (this.setQuest(response.data))) //this.quest = response.data
      .catch((error) => console.log(error));
    await api
      .getProfilePic(
        readToken(this.$store),
        this.patient!.id
      )
      .then((response) => (responseb64 = response.data))
      .catch((error) => console.log(error));
    this.imgDataUrl = this.b64Cleaner(responseb64);
    dispatchGetVisits(this.$store, this.patient!.id);
    dispatchGetVisitsQuest(this.$store, this.patient!.id);
    this.dialogInfo = readEditHorse(this.$store);
    this.setPatientInfo();
  }

  private formatDate(dateTimeStr) {
    const [datePart] = dateTimeStr.split(',');       // "21.3.2025"
    const [day, month, year] = datePart.split('.');  // ["21", "3", "2025"]

    // Pad day and month with leading zero if needed
    const paddedDay = day.padStart(2, '0');
    const paddedMonth = month.padStart(2, '0');

    return `${year}-${paddedMonth}-${paddedDay}`;
  }

  private setQuest(quests: QuestObjectMeasurement[]) {
    console.log("Setting quests now");
    console.log(quests);
    var anamnesis = "";
    try {

      anamnesis = quests[4].value_char;
    } catch (error) {
      console.log("Error setting quests: " + error);
    }
    try {
      this.quest = {
        vacc_state: quests[0].value_char,
        living_cond: quests[1].value_char,
        abrasion: quests[2].value_char,
        nurtri_state: quests[3].value_char,
        date: quests[0].creation_date,
        anamnesis: anamnesis,
      };
    } catch (error) {
      console.log("Error setting quests: " + error);
    }
  }

  public downloadWounds() {
    var pdf = new jsPDF();
    var textPDF = "";
    this.wounds.forEach((element) => (textPDF += element + "" + +"\n"));
    //pdf.addImage()
    pdf.text(textPDF, 10, 10);
    pdf.save("users.pdf");
  }

  private closeInfo() {
    this.setPatientInfo()
    this.dialogInfo = false;
  }

  public beforeDestroy() {
    if (this.set) {
      this.savePatient();
    }
  }
  public async savePatient() {
    this.dialogInfo = false;
    var updatePatient: IPatientProfileUpdate = {
      firstname: this.firstname,
      lastname: this.lastname,
    };
    if (this.gender != this.patient?.gender) {
      updatePatient.gender = this.gender;
    }
    if (this.road != this.patient?.road) {
      updatePatient.road = this.road;
    }
    if (this.house_number != this.patient?.house_number) {
      updatePatient.house_number = this.house_number;
    }
    if (this.postcode != this.patient?.postcode && this.postcode != 0) {
      updatePatient.postcode = this.postcode;
    }
    if (this.city != this.patient?.city) {
      updatePatient.city = this.city;
    }
    if (this.birthplace != this.patient?.birthplace) {
      updatePatient.birthplace = this.birthplace;
    }
    if (this.patient?.birthday) {
      if (this.birthday.toString() != new Date(1900, 1, 1).toString()) {
        if (this.birthday.toString() != this.patient?.birthday.toString())
          updatePatient.birthday = this.birthday;
      }
    }
    if (this.nationality != this.patient?.nationality) {
      updatePatient.nationality = this.nationality;
    }
    if (this.breed != this.patient?.breed) {
      updatePatient.breed = this.breed;
    }
    if (this.imgDataUrl && this.set) {
      let b64 = this.imgDataUrl;
      console.log(b64)
      try {
        await dispatchUpdatePatient(this.$store, {
          id: Number(this.patient?.id),
          patient: updatePatient,
          file: b64 as string,
        });
      } catch (e) {

      }
    } else {
      await dispatchUpdatePatient(this.$store, {
        id: Number(this.patient?.id),
        patient: updatePatient,
        file: "null",
      });
    }
    await dispatchGetPatients(this.$store);
    this.dialogInfo = false;
    this.editable = false;
  }

  public deletePatientIni() {
    this.dialogDelete = true;
  }

  public deleteHoove() {
    this.dialogDeleteHoove = true;
  }

  public no() {
    this.dialogDelete = false;
  }

  public noHoove() {
    this.dialogDeleteHoove = false;
  }

  public async deletePatient() {
    await api
      .deletePatient(readToken(this.$store), Number(this.$route.params.id))
      .catch((error) => console.log(error));
    const user = readUserProfile(this.$store)
    if (user?.is_superuser) {
      this.$router.push("/main/horse/users/all");
    } else {
      this.$router.push("/main/dashboard");
    }
  }


  public editHorse() {
    this.dialogInfo = true;
    this.editable = true;
  }

  public downloadQR() {
    var pdf = new jsPDF();
    var textPDF = "";
    pdf.setFontSize(18);
    textPDF = "Name: ";
    if (this.patient) {
      if (this.patient.firstname) {
        textPDF += this.patient.firstname + " ";
      }
      if (this.patient.lastname) {
        textPDF += this.patient.lastname;
      }
    }
    pdf.text(textPDF, 5, 20);
    if (this.language) {
      textPDF = "Address: " + this.patientAdress;
    } else {
      textPDF = "Adresse: " + this.patientAdress;
    }
    pdf.text(textPDF, 5, 30);
    pdf.addImage(this.getQR(), "JPEG", 3, 40, 200, 200);
    pdf.save("qrcode_patient_" + this.patient?.id);
  }

  public downloadPatient() {
    const pdf = new jsPDF();
    const pdfName = "patient_" + this.patient!.id + ".pdf";
    // var nurseText = "";
    // this.nurses.forEach(
    //   (element) =>
    //     (nurseText +=
    //       element.firstname +
    //       " " +
    //       element.lastname +
    //       "(ID:" +
    //       element.id +
    //       ");  ")
    // );
    // var textPDF =
    //   "Name: " +
    //   this.patient!.firstname +
    //   " " +
    //   this.patient!.lastname +
    //   "(ID: " +
    //   this.patient!.id +
    //   ")\n" +
    //   "Responsible Nurse(s): " +
    //   nurseText;
    // //pdf.addImage()
    // pdf.text(textPDF, 20, 20);var elementHTML = $('#contnet').html();

    // // pdf.html(html);
    // var img = new Image();
    // img.src = "../../images/logo.png";
    // pdf.addImage(img, "PNG", 14, 40, 450, 450);
    // pdf.save(pdfName);
  }

}
